import React, { ReactElement } from "react";

import Spinner from "../Spinner";
import { cn } from "../helpers";

const Button: React.FC<{
  text?: string;
  type?: "button" | "submit" | "reset" | undefined;
  variant?:
    | "contained"
    | "contained-inverted"
    | "outlined"
    | "outlined-white"
    | "text";
  fullWidth?: boolean;
  isLoading?: boolean;
  icon?: ReactElement;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({
  text,
  type = "button",
  variant = "contained",
  isLoading = false,
  icon = undefined,
  disabled = false,
  onClick,
}) => {
  const getStyling = (
    variant:
      | "contained"
      | "contained-inverted"
      | "outlined"
      | "outlined-white"
      | "text"
  ) => {
    switch (variant) {
      case "outlined":
        return `text-primary bg-opacity-0 bg-white border border-primary ${
          disabled ? "" : "hover:text-primaryHover hover:border-primaryHover"
        }`;
      case "outlined-white":
        return `text-white bg-opacity-0 ${
          disabled ? "" : "hover:bg-opacity-10"
        }  bg-white border border-white`;
      case "text":
        return `text-primary ${disabled ? "" : "hover:text-primaryHover"}`;
      case "contained-inverted":
        return cn(
          `text-primary bg-pitchlerGray ${
            disabled
              ? ""
              : "hover:bg-pitchlerGrayHover transition-all duration-400"
          }`
        );
      default:
        return cn(
          `text-white bg-primary`,
          "shadow-[0px 19px 8px rgba(0, 0, 0, 0.01), 0px 11px 6px rgba(0, 0, 0, 0.05), 0px 5px 5px rgba(0, 0, 0, 0.09), 0px 1px 3px rgba(0, 0, 0, 0.1)]",
          {
            "transition-all duration-500 hover:bg-black hover:shadow-[0px 2px 2px rgba(0, 0, 0, 0.01), 0px 2px 2px rgba(0, 0, 0, 0.05), 0px 1px 1px rgba(0, 0, 0, 0.09), 0px 1px 1px rgba(0, 0, 0, 0.0)]":
              !disabled,
          }
        );
    }
  };
  let variantStyling = getStyling(variant);

  const disabledStyling = disabled ? "opacity-70" : "";

  return (
    <button
      type={type}
      className={`${variantStyling} block w-full rounded-3xl px-4 py-3 text-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary  ${disabledStyling}`}
      onClick={onClick}
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        <Spinner width={20} />
      ) : (
        <div className={cn("flex flex-row justify-center space-x-2")}>
          {text && <div>{text}</div>}
          {icon}
        </div>
      )}
    </button>
  );
};

export default Button;
